module.exports = __webpack_public_path__ + "img/app_image.d859831a.png";